import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { errorInterceptor, loadingInterceptor, responseInterceptor } from '../app/core/interceptors';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

import { publicRoutes } from './app.routes';

const PharmigoPrimeTheme = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#e6f7f6',
      100: '#b3e8e4',
      200: '#80d9d2',
      300: '#4dcac0',
      400: '#26beb2',
      500: '#03a297',
      600: '#029387',
      700: '#027a70',
      800: '#016159',
      900: '#014842',
      950: '#002f2b'
    }
  }
});

export const publicAppConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    MessageService,
    provideRouter(publicRoutes, withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
    provideAnimationsAsync(),
    // authInterceptor excluded — public app has no authenticated routes
    provideHttpClient(withInterceptors([loadingInterceptor, responseInterceptor, errorInterceptor])),
    providePrimeNG({
      theme: {
        preset: PharmigoPrimeTheme,
        options: {
          darkModeSelector: '.dark-mode'
        }
      }
    })
  ]
};
